import { GridSortModel } from "@mui/x-data-grid-pro";
import { Dayjs } from "dayjs";
import { MyLocatorInventoryItem } from "../components/MyLocatorInventoryTable/MyLocatorInventoryTable";
import { MyLocatorInventoryFilters } from "../types";

export enum MyLocatorInventoryActionsType {
  SET_INVENTORY_ITEMS = "SET_INVENTORY_ITEMS",
  SET_IS_LOADING = "SET_IS_LOADING",
  SET_IS_TECHNICAL_ERROR = "SET_IS_TECHNICAL_ERROR",
  SET_IS_AUTHENTICATION_ERROR = "SET_IS_AUTHENTICATION_ERROR",
  SET_FILTER = "SET_FILTER",
  SET_PAGE_ROW_SIZE = "SET_PAGE_ROW_SIZE",
  SET_CURRENT_PAGE = "SET_CURRENT_PAGE",
  SET_TOTAL_INVENTORY_ITEMS = "SET_TOTAL_INVENTORY_ITEMS",
  SET_SORT_MODEL = "SET_SORT_MODEL",
  SET_DATE_RANGE_FILTER_ACTION = "SET_DATE_RANGE_FILTER_ACTION",
  SET_ALL_INVENTORY_ITEMS = "SET_ALL_INVENTORY_ITEMS",
  SET_IS_LOADING_MORE = "SET_IS_LOADING_MORE",
  APPEND_INVENTORY_ITEMS = "APPEND_INVENTORY_ITEMS",
}

type SetInventoryItemsAction = {
  type: MyLocatorInventoryActionsType.SET_INVENTORY_ITEMS;
  payload: {
    inventoryItems: MyLocatorInventoryItem[];
    totalInventoryItems: number;
  };
};

type SetIsLoadingAction = {
  type: MyLocatorInventoryActionsType.SET_IS_LOADING;
  payload: boolean;
};

type SetIsTechnicalErrorAction = {
  type: MyLocatorInventoryActionsType.SET_IS_TECHNICAL_ERROR;
  payload: boolean;
};

type SetIsAuthenticationErrorAction = {
  type: MyLocatorInventoryActionsType.SET_IS_AUTHENTICATION_ERROR;
  payload: boolean;
};

type SetFilterAction = {
  type: MyLocatorInventoryActionsType.SET_FILTER;
  payload: MyLocatorInventoryFilters;
};

type SetPageRowSizeAction = {
  type: MyLocatorInventoryActionsType.SET_PAGE_ROW_SIZE;
  payload: number;
};

type SetCurrentPageAction = {
  type: MyLocatorInventoryActionsType.SET_CURRENT_PAGE;
  payload: number;
};

type SetTotalInventoryItemsAction = {
  type: MyLocatorInventoryActionsType.SET_TOTAL_INVENTORY_ITEMS;
  payload: number;
};

type SetSortModelAction = {
  type: MyLocatorInventoryActionsType.SET_SORT_MODEL;
  payload: GridSortModel;
};

type SetDateRangeFilterAction = {
  type: MyLocatorInventoryActionsType.SET_DATE_RANGE_FILTER_ACTION;
  payload: {
    startDate: Dayjs;
    endDate: Dayjs;
  };
};

type SetAllInventoryItemsAction = {
  type: MyLocatorInventoryActionsType.SET_ALL_INVENTORY_ITEMS;
  payload: MyLocatorInventoryItem[];
};

type SetIsLoadingMoreAction = {
  type: MyLocatorInventoryActionsType.SET_IS_LOADING_MORE;
  payload: boolean;
};

type AppendInventoryItemsAction = {
  type: MyLocatorInventoryActionsType.APPEND_INVENTORY_ITEMS;
  payload: MyLocatorInventoryItem[];
};

export type MyLocatorInventoryActions =
  | SetInventoryItemsAction
  | SetIsLoadingAction
  | SetIsTechnicalErrorAction
  | SetIsAuthenticationErrorAction
  | SetFilterAction
  | SetPageRowSizeAction
  | SetCurrentPageAction
  | SetTotalInventoryItemsAction
  | SetSortModelAction
  | SetDateRangeFilterAction
  | SetAllInventoryItemsAction
  | SetIsLoadingMoreAction
  | AppendInventoryItemsAction;

export function setInventoryItemsAction(payload: {
  inventoryItems: MyLocatorInventoryItem[];
  totalInventoryItems: number;
}): SetInventoryItemsAction {
  return {
    type: MyLocatorInventoryActionsType.SET_INVENTORY_ITEMS,
    payload,
  };
}

export function setIsLoadingAction(isLoading: boolean): SetIsLoadingAction {
  return {
    type: MyLocatorInventoryActionsType.SET_IS_LOADING,
    payload: isLoading,
  };
}

export function setIsTechnicalErrorAction(
  isTechnicalError: boolean
): SetIsTechnicalErrorAction {
  return {
    type: MyLocatorInventoryActionsType.SET_IS_TECHNICAL_ERROR,
    payload: isTechnicalError,
  };
}

export function setIsAuthenticationErrorAction(
  isAuthenticationError: boolean
): SetIsAuthenticationErrorAction {
  return {
    type: MyLocatorInventoryActionsType.SET_IS_AUTHENTICATION_ERROR,
    payload: isAuthenticationError,
  };
}

export function setFilterAction(
  filters: MyLocatorInventoryFilters
): SetFilterAction {
  return {
    type: MyLocatorInventoryActionsType.SET_FILTER,
    payload: filters,
  };
}

export function setPageRowSizeAction(
  pageRowSize: number
): SetPageRowSizeAction {
  return {
    type: MyLocatorInventoryActionsType.SET_PAGE_ROW_SIZE,
    payload: pageRowSize,
  };
}

export function setCurrentPageAction(
  currentPage: number
): SetCurrentPageAction {
  return {
    type: MyLocatorInventoryActionsType.SET_CURRENT_PAGE,
    payload: currentPage,
  };
}

export function setTotalInventoryItemsAction(
  totalInventoryItems: number
): SetTotalInventoryItemsAction {
  return {
    type: MyLocatorInventoryActionsType.SET_TOTAL_INVENTORY_ITEMS,
    payload: totalInventoryItems,
  };
}

export function setSortModelAction(
  sortModel: GridSortModel
): SetSortModelAction {
  return {
    type: MyLocatorInventoryActionsType.SET_SORT_MODEL,
    payload: sortModel,
  };
}

export function setDateRangeFilterAction(
  startDate: Dayjs,
  endDate: Dayjs
): SetDateRangeFilterAction {
  return {
    type: MyLocatorInventoryActionsType.SET_DATE_RANGE_FILTER_ACTION,
    payload: {
      startDate,
      endDate,
    },
  };
}

export function setAllInventoryItemsAction(
  inventoryItems: MyLocatorInventoryItem[]
): SetAllInventoryItemsAction {
  return {
    type: MyLocatorInventoryActionsType.SET_ALL_INVENTORY_ITEMS,
    payload: inventoryItems,
  };
}

export function setIsLoadingMoreAction(
  isLoadingMore: boolean
): SetIsLoadingMoreAction {
  return {
    type: MyLocatorInventoryActionsType.SET_IS_LOADING_MORE,
    payload: isLoadingMore,
  };
}

export function appendInventoryItemsAction(
  inventoryItems: MyLocatorInventoryItem[]
): AppendInventoryItemsAction {
  return {
    type: MyLocatorInventoryActionsType.APPEND_INVENTORY_ITEMS,
    payload: inventoryItems,
  };
}
